<script>
import { mapState, mapActions } from 'vuex';
import TwTitleBar from '../../components/TwTitleBar';

export default {
  name: 'ItineraryPricesWrapper',
  components: {
    TwTitleBar,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t('menu.itinerary.title'),
          to: `/itinerary/edit/${this.$route.params.id}/general`,
        },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path, disabled: true },
      ],
    };
  },
  created() {
    this.getItinerary(this.$route.params.id).then(() => {
      this.getDomainsByProductTypeId(this.currentItinerary.productTypeId);
    });
  },
  computed: {
    ...mapState({
      availableDomains: state => state.app.domains.items,
      currentItinerary: state => state.itinerary.edit.item,
    }),
  },
  methods: {
    ...mapActions({
      getDomainsByProductTypeId: 'app/getDomainsByProductTypeId',
      getItinerary: 'itinerary/getItinerary',
      resetDataForDomainChange: 'itinerary/resetDataForDomainChange',
      getItineraryPriceIntervals: 'itinerary/getItineraryPriceIntervals',
    }),
    createPath(domainId) {
      return `/itinerary/prices/${this.$route.params.id}/${domainId}`;
    },
    changeItineraryDomain(domainId) {
      // Reset all price data
      this.resetDataForDomainChange();
      const payload = { itineraryId: this.$route.params.id, domainId };
      // Fetch new price data
      this.getItineraryPriceIntervals(payload);
    },
  },
};
</script>

<template>
  <v-content>
    <tw-title-bar
      :title="$t('menu.itinerary.priceinterval.title')"
      :breadcrumbs="breadcrumbs"
    >
    </tw-title-bar>
    <div class="pa-2">
      <h2 class="mb-2 ml-3" v-if="currentItinerary">{{ currentItinerary.name }}</h2>
      <v-card>
        <v-tabs fixed-tabs class="pb-3">
          <v-tab
            v-for="domain in currentItinerary.domains"
            :key="domain.id"
            :to="createPath(domain.id)"
            :value="domain.id"
            @click="changeItineraryDomain(domain.id)"
          >
            {{ domain.shortName }}
          </v-tab>
        </v-tabs>
      </v-card>
      <router-view />
    </div>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryPricesRoutingWrapper.vue